
const digest = '52d4af9e33d900b068538e386ec658db389ee5092bb9af0743d113e5cadff45f';
const classes = {"wrapper":"_wrapper_1vlv4_1","controls":"_controls_1vlv4_11","invalidPatientText":"_invalidPatientText_1vlv4_17"};
const css = `._wrapper_1vlv4_1 {
  font-family: Rubik, "sans-serif";
  border: 1px solid #eaedf3;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  background: #ffffff;
}
._wrapper_1vlv4_1 ._controls_1vlv4_11 {
  padding: 24px;
  margin-top: 20px;
  display: flex;
}

._invalidPatientText_1vlv4_17 {
  font-weight: 500;
  font-size: 14px;
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  